import { CostCategoryDisplay } from '@/types/thermostatCostCategoryControls'

export default function checkUserCanAccessTstatSaveMoney(
  costCategories: CostCategoryDisplay[],
): boolean {
  return costCategories.length > 0
}
